module.exports = __webpack_public_path__ + "static/media/logo.a879d8f3.svg";